module.exports = __webpack_public_path__ + "Server-Healthy.AzureCloudService.cbda99bff3000523d16de4605fadd1ad.hashedasset.svg";